import { useState } from 'react';
import { Modal } from 'react-bootstrap-v5'
import ModalImpressoes from './modal-impressoes';
import ModalProcessarArquivos from './modal-processar-arquivos';
import RelatoriosService from '../../services/RelatoriosService';
/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';

const ModalMapaConciliacao = ({ esteiraID, empresaID, show, toggleModal, onSetMostrarReferencial }: { show: boolean, toggleModal: Function, esteiraID: number, empresaID: number, onSetMostrarReferencial: Function }) => {
    const { t } = useTranslation();
    const [showImpressoes, setShowImpressoes] = useState<boolean>(false);
    const [showProcessarArquivos, setShowProcessarArquivos] = useState<boolean>(false);
    const [semMovimentacao, setSemMovimentacao] = useState<boolean>(true);
    const [ignorarContasSemPorcento, setIgnorarContasSemPorcento] = useState<boolean>(false);
    const [mostrarReferencial, setMostrarReferencial] = useState<boolean>(true);
    const [status, setstatus] = useState<string>('Concluida');
    const [grupo, setGrupo] = useState<string>('todas');
    const [carregandoImprimirBook, setCarregandoImprimirBook] = useState<boolean>(false);

    return (
        <>
            <ModalImpressoes esteiraID={esteiraID} show={showImpressoes} toggleModal={() => setShowImpressoes(false)} />
            <ModalProcessarArquivos empresaID={empresaID} esteiraID={esteiraID} show={showProcessarArquivos} toggleModal={() => setShowProcessarArquivos(false)} />
            <Modal size='sm' centered={true} show={show && !showImpressoes && !showProcessarArquivos} onHide={toggleModal}>
                <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                    <div className="modal-header">
                        <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Exportar</h5>
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <button onClick={() => toggleModal()} style={{ backgroundColor: 'none', border: 'none' }}>
                                <i className="fas fa-times" style={{ color: '#5E6397' }}></i>
                            </button>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className='col-md-12 mt-2'>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" checked={ignorarContasSemPorcento} onChange={() => setIgnorarContasSemPorcento((old) => !old)} />
                                    <label className="form-check-label">
                                        {t("Ignorar contas 100% conciliadas.")}
                                    </label>
                                </div>
                            </div>
                            <div className='col-md-12 mt-2'>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" checked={semMovimentacao} onChange={() => setSemMovimentacao((old) => !old)} />
                                    <label className="form-check-label">
                                        {t("Remover cards sem movimentação")}
                                    </label>
                                </div>
                            </div>
                            <div className='col-md-12 mt-2'>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" checked={mostrarReferencial} onChange={() => {
                                        setMostrarReferencial((old) => {
                                            const value = !old
                                            onSetMostrarReferencial(value)
                                            return value
                                        })
                                    }} />
                                    <label className="form-check-label">
                                        {t("Mostrar referêncial na impressão")}
                                    </label>
                                </div>
                            </div>
                            <div className='col-md-12 form-group mt-2'>
                                <label>{t("Status")}</label>
                                <select className='form-control' value={status} onChange={(e) => setstatus(e.target.value)}>
                                    <option value='todas'>{t("Todos")}</option>
                                    <option value='Conciliado Parcial'>{t("Conciliado Parcial")}</option>
                                    <option value='Conciliacao'>{t("Conciliação Inteligente")}</option>
                                    <option value='Em Conferencia'>{t("Em Conferência")}</option>
                                    <option value='Concluida'>{t("Concluído")}</option>
                                </select>
                            </div>
                            <div className='col-md-12 form-group mt-2'>
                                <label>{t("Grupo: ")}</label>
                                <select className='form-control' value={grupo} onChange={(e) => setGrupo(e.target.value)}>
                                    <option value='todas'>{t("Todos")}</option>
                                    <option value='clienteFornecedor'>{t("Cliente/Fornecedor")}</option>
                                    <option value='tributo'>{t("Tributos")}</option>
                                    <option value='imobilizado'>{t("Imobilizado")}</option>
                                    <option value='pl'>PL</option>
                                    <option value='emprestimo'>{t("Empréstimo")}</option>
                                </select>
                            </div>
                            <div className="col-md-12 mt-2">
                                <button style={{ width: '100%' }} className='btn btn-success' onClick={() => setShowImpressoes(true)}>{t("Exportações")}</button>
                            </div>
                            <div className="col-md-12 mt-2" >
                                <button style={{ width: '100%' }} onClick={() => {
                                    setCarregandoImprimirBook(true);
                                    RelatoriosService.impressaoTodos(esteiraID, mostrarReferencial, semMovimentacao, ignorarContasSemPorcento, grupo, status, () => {
                                        setCarregandoImprimirBook(false);
                                    });
                                }} className='btn btn-success'>{carregandoImprimirBook ? t('Carregando...') : t('Imprimir Book')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ModalMapaConciliacao